import { ca } from '@cian/analytics';
import { IOfferSchema, IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { getProducts } from './tracking/get_products';

export function trackKPLinkClick(label: string, offer: IOfferSchema, agent: IAgentSchema | null, kpId: number | null) {
  const products = getProducts(agent, offer, kpId);

  ca('eventSite', {
    action: 'goto_CardKP',
    category: 'card',
    label,
    name: 'oldevent',
    products: [{ ...products, variant: products.variant ? products.variant.split('/') : [] }],
  });
}
